export enum CustomerRole {
  qlkh_cap_nhat = 'QLKH_CAP_NHAT',
  qlkh_them = 'QLKH_THEM',
  qlkh_xem_chi_tiet = 'QLKH_XEM_CHI_TIET',
  qlkh_xem_danh_sach = 'QLKH_XEM_DANH_SACH',
}
